import { render, staticRenderFns } from "./CharacterSelection.vue?vue&type=template&id=0a97cf6c&scoped=true&"
import script from "./CharacterSelection.vue?vue&type=script&lang=js&"
export * from "./CharacterSelection.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSelection.vue?vue&type=style&index=0&id=0a97cf6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97cf6c",
  null
  
)

export default component.exports